import Vue from "vue";

const actions = {
  invoices(context, payload) {
    return Vue.prototype.$http.get("/api/invoices/v1" + (payload || ""));
  },
  downloadInvoice(context, { invoice_uuid }) {
    return Vue.prototype.$http.get(
      `/api/invoices/v1/${invoice_uuid}/download`,
      { responseType: "blob" }
    );
  }
};

export const invoice = {
  namespaced: true,
  state: {},
  actions,
  mutations: {},
  getters: {}
};
